import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/down.png'
import _imports_1 from '../../assets/performance/footer.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-0548d60d")

_pushScopeId("data-v-0548d60d")
const _hoisted_1 = {
  class: "Ecard",
  id: "trendChart"
}
const _hoisted_2 = { class: "testMain" }
const _hoisted_3 = { class: "fitter_title" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("发送报告")
const _hoisted_5 = /*#__PURE__*/_createVNode("span", null, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1)
const _hoisted_6 = { class: "banner_btn" }
const _hoisted_7 = { class: "dialogTitle" }
const _hoisted_8 = /*#__PURE__*/_createVNode("span", null, "AIGC Banner", -1)
const _hoisted_9 = { style: {"text-align":"center","margin":"20px 0px","color":"#3d86fb","font-size":"16px","font-weight":"bold"} }
const _hoisted_10 = { class: "dialog-footer" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("预览")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("确认")
const _hoisted_14 = { class: "dialogTitle" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode("手动生成报告-按任务")
const _hoisted_16 = /*#__PURE__*/_createVNode("i", { class: "el-icon-message-solid" }, null, -1)
const _hoisted_17 = /*#__PURE__*/_createTextVNode("生成报告")
const _hoisted_18 = { class: "dialogTitle" }
const _hoisted_19 = /*#__PURE__*/_createVNode("span", null, "手动生成报告", -1)
const _hoisted_20 = /*#__PURE__*/_createTextVNode("生成报告")
const _hoisted_21 = {
  key: 0,
  class: "editRecipient"
}
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" 可按如下任一形式批量添加： ")
const _hoisted_23 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_24 = /*#__PURE__*/_createTextVNode("1、zhangsan;lisi;wangwu ")
const _hoisted_25 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_26 = /*#__PURE__*/_createTextVNode("2、zhangsan(张三);lisi(李四);wangwu(王五) ")
const _hoisted_27 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_28 = /*#__PURE__*/_createTextVNode("3、zhangsan(张三) <zhangsan@tencent.com>;lisi(李四) <lisi@tencent.com>; wangwu(王五) <wangwu@tencent.com> ")
const _hoisted_29 = /*#__PURE__*/_createVNode("span", null, "发送报告", -1)
const _hoisted_30 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_31 = { id: "perf_report" }
const _hoisted_32 = { class: "spacName" }
const _hoisted_33 = { class: "mainContent" }
const _hoisted_34 = { class: "spacName" }
const _hoisted_35 = { class: "gameTable" }
const _hoisted_36 = {
  rowspan: 3,
  class: "gameIcon"
}
const _hoisted_37 = {
  colspan: 3,
  class: "game_name"
}
const _hoisted_38 = /*#__PURE__*/_createTextVNode(" 测试版本: ")
const _hoisted_39 = /*#__PURE__*/_createTextVNode(" 报告创建时间: ")
const _hoisted_40 = /*#__PURE__*/_createTextVNode(" 创建者: ")
const _hoisted_41 = /*#__PURE__*/_createTextVNode(" 风险等级: ")
const _hoisted_42 = /*#__PURE__*/_createVNode("td", null, [
  /*#__PURE__*/_createTextVNode(" 测试类型: "),
  /*#__PURE__*/_createVNode("span", null, "自动化深度性能测试")
], -1)
const _hoisted_43 = /*#__PURE__*/_createTextVNode(" 测试平台: ")
const _hoisted_44 = { class: "corePerformance spacName" }
const _hoisted_45 = { class: "spacName" }
const _hoisted_46 = /*#__PURE__*/_createVNode("h5", { class: "TitleStyle" }, [
  /*#__PURE__*/_createVNode("span"),
  /*#__PURE__*/_createTextVNode("一、测试结论")
], -1)
const _hoisted_47 = { style: {"margin-left":"5px"} }
const _hoisted_48 = /*#__PURE__*/_createTextVNode("(")
const _hoisted_49 = /*#__PURE__*/_createTextVNode(") ")
const _hoisted_50 = { class: "spacName" }
const _hoisted_51 = /*#__PURE__*/_createVNode("h5", { class: "TitleStyle" }, [
  /*#__PURE__*/_createVNode("span"),
  /*#__PURE__*/_createTextVNode("二、包体整体监控")
], -1)
const _hoisted_52 = /*#__PURE__*/_createVNode("span", { class: "subTitle" }, "◆", -1)
const _hoisted_53 = /*#__PURE__*/_createTextVNode(" 包体迭代趋势 ")
const _hoisted_54 = /*#__PURE__*/_createVNode("div", {
  id: "chart",
  style: {"height":"500px","width":"100%"}
}, null, -1)
const _hoisted_55 = /*#__PURE__*/_createVNode("span", { class: "subTitle" }, "◆", -1)
const _hoisted_56 = /*#__PURE__*/_createTextVNode(" 按类占比分类 ")
const _hoisted_57 = { class: "spacName" }
const _hoisted_58 = /*#__PURE__*/_createVNode("h5", { class: "TitleStyle" }, [
  /*#__PURE__*/_createVNode("span"),
  /*#__PURE__*/_createTextVNode("三、主资产监控")
], -1)
const _hoisted_59 = /*#__PURE__*/_createVNode("span", { class: "subTitle" }, "◆", -1)
const _hoisted_60 = /*#__PURE__*/_createTextVNode(" 主资产版本错误引用条数统计 ")
const _hoisted_61 = /*#__PURE__*/_createVNode("div", { class: "footer" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_1,
    alt: ""
  })
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_divider = _resolveComponent("el-divider")
  const _component_el_image = _resolveComponent("el-image")
  const _component_el_dialog = _resolveComponent("el-dialog")
  const _component_el_tooltip = _resolveComponent("el-tooltip")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_table = _resolveComponent("el-table")
  const _component_h8 = _resolveComponent("h8")
  const _component_el_card = _resolveComponent("el-card")
  const _component_el_main = _resolveComponent("el-main")
  const _component_el_container = _resolveComponent("el-container")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock(_component_el_container, null, {
    default: _withId(() => [
      _createVNode(_component_el_container, null, {
        default: _withId(() => [
          _createVNode(_component_el_main, null, {
            default: _withId(() => [
              _createVNode("div", _hoisted_1, [
                _createVNode("div", _hoisted_2, [
                  _createVNode("div", _hoisted_3, [
                    _createVNode(_component_el_form, {
                      inline: true,
                      size: "mini",
                      class: "spacForm"
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_el_form_item, { label: "新版本" }, {
                          default: _withId(() => [
                            _createVNode(_component_el_select, {
                              modelValue: _ctx.id_test,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.id_test = $event)),
                              onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.versionChange('new'))),
                              placeholder: "请选择"
                            }, {
                              default: _withId(() => [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.listOptions, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item.id_test,
                                    label: item.version,
                                    value: item.id_test
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, { label: "旧版本" }, {
                          default: _withId(() => [
                            _createVNode(_component_el_select, {
                              modelValue: _ctx.old_test,
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.old_test = $event)),
                              placeholder: "请选择",
                              onChange: _ctx.versionChange
                            }, {
                              default: _withId(() => [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.listOptions, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item.id_test,
                                    label: item.version,
                                    value: item.id_test
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue", "onChange"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, null, {
                          default: _withId(() => [
                            _createVNode(_component_el_button, {
                              type: "primary",
                              onClick: _ctx.sendOut,
                              class: "down_img"
                            }, {
                              default: _withId(() => [
                                _hoisted_4,
                                _hoisted_5
                              ]),
                              _: 1
                            }, 8, ["onClick"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _createVNode("div", _hoisted_6, [
                    _createVNode(_component_el_dialog, {
                      modelValue: _ctx.test,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.test = $event)),
                      width: "790px",
                      class: "banner_btn"
                    }, {
                      title: _withId(() => [
                        _createVNode("div", _hoisted_7, [
                          _hoisted_8,
                          _createVNode(_component_el_divider)
                        ])
                      ]),
                      footer: _withId(() => [
                        _createVNode("span", _hoisted_10, [
                          _createVNode(_component_el_button, {
                            size: "small",
                            onClick: _ctx.Preview_btn
                          }, {
                            default: _withId(() => [
                              _hoisted_11
                            ]),
                            _: 1
                          }, 8, ["onClick"]),
                          _createVNode(_component_el_button, {
                            type: "info",
                            size: "small",
                            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.test = false))
                          }, {
                            default: _withId(() => [
                              _hoisted_12
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_button, {
                            size: "small",
                            type: "success",
                            onClick: _ctx.confirm_btn
                          }, {
                            default: _withId(() => [
                              _hoisted_13
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ])
                      ]),
                      default: _withId(() => [
                        _createVNode(_component_el_form, null, {
                          default: _withId(() => [
                            _createVNode(_component_el_form_item, {
                              inline: true,
                              size: "mini",
                              label: "Banner主题"
                            }, {
                              default: _withId(() => [
                                _createVNode(_component_el_select, {
                                  modelValue: _ctx.banner_name,
                                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.banner_name = $event)),
                                  placeholder: "请选择",
                                  onChange: _ctx.bannerChang
                                }, {
                                  default: _withId(() => [
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.bannerList, (item) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: item,
                                        label: item,
                                        value: item
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["modelValue", "onChange"])
                              ]),
                              _: 1
                            }),
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.banner_name == '全部'
                      ? _ctx.banner_img
                      : _ctx.banner_img.filter((v) => v.name == _ctx.banner_name), (item) => {
                              return (_openBlock(), _createBlock("div", {
                                key: item.name
                              }, [
                                _createVNode("div", _hoisted_9, _toDisplayString(item.name), 1),
                                _createVNode("div", null, [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(item.value, (url, index) => {
                                    return (_openBlock(), _createBlock(_component_el_image, {
                                      onClick: ($event: any) => (_ctx.imgBtn(index, url, item.name)),
                                      class: "img_border",
                                      style: 
                          'margin-bottom:10px;border:' +
                          (index === _ctx.img_index && item.name === _ctx.img_name
                            ? '2px solid #3D86FB;'
                            : '2px solid #F5F6FA')
                        ,
                                      key: index,
                                      src: url,
                                      lazy: ""
                                    }, null, 8, ["onClick", "style", "src"]))
                                  }), 128))
                                ])
                              ]))
                            }), 128))
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _createVNode(_component_el_dialog, {
                    modelValue: _ctx.dialogFormVisibleByTask,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.dialogFormVisibleByTask = $event)),
                    width: "790px"
                  }, {
                    title: _withId(() => [
                      _createVNode("div", _hoisted_14, [
                        _createVNode("span", null, [
                          _hoisted_15,
                          _createVNode(_component_el_tooltip, {
                            class: "item",
                            effect: "dark",
                            content: "如只选择测试任务, 则按照任务完成自动生成报告的逻辑生成一份报告",
                            placement: "top"
                          }, {
                            default: _withId(() => [
                              _hoisted_16
                            ]),
                            _: 1
                          })
                        ]),
                        _createVNode(_component_el_divider)
                      ])
                    ]),
                    footer: _withId(() => [
                      _createVNode(_component_el_button, {
                        type: "primary",
                        onClick: _ctx.generateReportByTask,
                        size: "small"
                      }, {
                        default: _withId(() => [
                          _hoisted_17
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]),
                    default: _withId(() => [
                      _createVNode(_component_el_form, {
                        inline: true,
                        model: _ctx.generateReportVersion,
                        "label-position": "top",
                        size: "small"
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_el_form_item, { label: "对比任务" }, {
                            default: _withId(() => [
                              _createVNode(_component_el_select, {
                                modelValue: _ctx.generateReportVersion.oldEdition,
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.generateReportVersion.oldEdition = $event)),
                                id: "old_version",
                                placeholder: "请选择"
                              }, {
                                default: _withId(() => [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.RecentTaskrecord, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item.value,
                                      label: item.label,
                                      value: item.value
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_form_item, { label: "测试任务" }, {
                            default: _withId(() => [
                              _createVNode(_component_el_select, {
                                modelValue: _ctx.generateReportVersion.newEdition,
                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.generateReportVersion.newEdition = $event)),
                                id: "new_version",
                                placeholder: "请选择"
                              }, {
                                default: _withId(() => [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.RecentTaskrecord, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item.value,
                                      label: item.label,
                                      value: item.value
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["model"])
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createVNode(_component_el_dialog, {
                    modelValue: _ctx.dialogFormVisible,
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.dialogFormVisible = $event)),
                    width: "790px"
                  }, {
                    title: _withId(() => [
                      _createVNode("div", _hoisted_18, [
                        _hoisted_19,
                        _createVNode(_component_el_divider)
                      ])
                    ]),
                    footer: _withId(() => [
                      _createVNode(_component_el_button, {
                        type: "primary",
                        onClick: _ctx.generateReport,
                        size: "small"
                      }, {
                        default: _withId(() => [
                          _hoisted_20
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]),
                    default: _withId(() => [
                      _createVNode(_component_el_form, {
                        inline: true,
                        model: _ctx.generateReportVersion,
                        "label-position": "top",
                        size: "small"
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_el_form_item, { label: "旧版本" }, {
                            default: _withId(() => [
                              _createVNode(_component_el_select, {
                                modelValue: _ctx.generateReportVersion.oldEdition,
                                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.generateReportVersion.oldEdition = $event)),
                                id: "old_version",
                                placeholder: "请选择"
                              }, {
                                default: _withId(() => [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.game_version_options, (item, index) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: index,
                                      label: item.label,
                                      value: item.value
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_form_item, { label: "新版本" }, {
                            default: _withId(() => [
                              _createVNode(_component_el_select, {
                                modelValue: _ctx.generateReportVersion.newEdition,
                                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.generateReportVersion.newEdition = $event)),
                                id: "new_version",
                                placeholder: "请选择",
                                onChange: _ctx.selectVersion
                              }, {
                                default: _withId(() => [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.game_version_options, (item, index) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: index,
                                      label: item.label,
                                      value: item.value
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue", "onChange"])
                            ]),
                            _: 1
                          }),
                          _withDirectives(_createVNode(_component_el_form_item, { label: "场景" }, {
                            default: _withId(() => [
                              _createVNode(_component_el_select, {
                                modelValue: _ctx.generateReportVersion.scenetion,
                                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.generateReportVersion.scenetion = $event)),
                                multiple: "",
                                placeholder: "请选择"
                              }, {
                                default: _withId(() => [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.game_scene_version, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item.scene_id_id,
                                      label: item.scene_id__chinese,
                                      value: item.scene_id_id
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          }, 512), [
                            [_vShow, _ctx.localProject != 34 && _ctx.localProject != 40]
                          ])
                        ]),
                        _: 1
                      }, 8, ["model"])
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  (_ctx.edit)
                    ? (_openBlock(), _createBlock("div", _hoisted_21, [
                        _createVNode(_component_el_form, {
                          "label-position": "left",
                          "label-width": "100px",
                          model: _ctx.formMail,
                          size: "mini"
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_form_item, { label: "邮件标题" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: _ctx.formMail.title,
                                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.formMail.title = $event))
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, { label: "邮件发件人" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_tooltip, { placement: "bottom" }, {
                                  content: _withId(() => [
                                    _createTextVNode(" 指定的邮件发件人需要位于公司TOF发件人名单,否则无法发送邮件。默认邮件发件人" + _toDisplayString(_ctx.formMail.Sender), 1)
                                  ]),
                                  default: _withId(() => [
                                    _createVNode(_component_el_input, {
                                      modelValue: _ctx.formMail.Sender,
                                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.formMail.Sender = $event))
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, { label: "邮件收件人" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_tooltip, { placement: "bottom" }, {
                                  content: _withId(() => [
                                    _hoisted_22,
                                    _hoisted_23,
                                    _hoisted_24,
                                    _hoisted_25,
                                    _hoisted_26,
                                    _hoisted_27,
                                    _hoisted_28
                                  ]),
                                  default: _withId(() => [
                                    _createVNode(_component_el_input, {
                                      modelValue: _ctx.formMail.addressee,
                                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.formMail.addressee = $event))
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, { label: "邮件抄送人" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: _ctx.formMail.CC_List,
                                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_ctx.formMail.CC_List = $event))
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_popconfirm, {
                              title: "确认发送报告吗？",
                              onConfirm: _cache[18] || (_cache[18] = ($event: any) => (_ctx.save_report(false))),
                              placement: "top"
                            }, {
                              reference: _withId(() => [
                                _createVNode(_component_el_button, {
                                  type: "primary",
                                  disabled: _ctx.get_is_super,
                                  size: "mini"
                                }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_tooltip, {
                                      effect: "dark",
                                      content: "暂无管理员权限",
                                      placement: "top",
                                      disabled: !_ctx.get_is_super
                                    }, {
                                      default: _withId(() => [
                                        _hoisted_29
                                      ]),
                                      _: 1
                                    }, 8, ["disabled"])
                                  ]),
                                  _: 1
                                }, 8, ["disabled"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_button, {
                              size: "mini",
                              type: "info",
                              onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.edit = false))
                            }, {
                              default: _withId(() => [
                                _hoisted_30
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["model"])
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode("div", _hoisted_31, [
                    _withDirectives(_createVNode("div", _hoisted_32, [
                      _createVNode("img", {
                        class: "banner",
                        src: _ctx.titleImg,
                        alt: ""
                      }, null, 8, ["src"])
                    ], 512), [
                      [_directive_loading, _ctx.loading]
                    ]),
                    _createVNode("div", _hoisted_33, [
                      _createVNode("div", _hoisted_34, [
                        _withDirectives(_createVNode("table", _hoisted_35, [
                          _createVNode("tr", null, [
                            _createVNode("td", _hoisted_36, [
                              _createVNode("img", {
                                src: _ctx.get_core_data.base.project_icon
                              }, null, 8, ["src"])
                            ]),
                            _createVNode("td", _hoisted_37, " 【" + _toDisplayString(_ctx.get_core_data.base.project_name) + "】 ", 1)
                          ]),
                          _createVNode("tr", null, [
                            _createVNode("td", null, [
                              _hoisted_38,
                              _createVNode("span", null, _toDisplayString(_ctx.get_core_data.base.version), 1)
                            ]),
                            _createVNode("td", null, [
                              _hoisted_39,
                              _createVNode("span", null, _toDisplayString(_ctx.get_core_data.base.date), 1)
                            ]),
                            _createVNode("td", null, [
                              _hoisted_40,
                              _createVNode("span", null, _toDisplayString(_ctx.get_core_data.base.creator), 1)
                            ])
                          ]),
                          _createVNode("tr", null, [
                            _createVNode("td", null, [
                              _hoisted_41,
                              _createVNode("span", {
                                style: 
                            'color:' + _ctx.getColor('低风险') + ';font-weight:bold'
                          
                              }, " 低风险 ", 4)
                            ]),
                            _hoisted_42,
                            _createVNode("td", null, [
                              _hoisted_43,
                              _createVNode("span", null, _toDisplayString(_ctx.get_core_data.base.device_type), 1)
                            ])
                          ])
                        ], 512), [
                          [_directive_loading, _ctx.loading]
                        ])
                      ]),
                      _withDirectives(_createVNode("div", _hoisted_44, [
                        _createVNode("div", _hoisted_45, [
                          _hoisted_46,
                          _createVNode("div", null, [
                            _createVNode(_component_el_table, {
                              border: "",
                              data: _ctx.conclusion,
                              "show-header": false
                            }, {
                              default: _withId(() => [
                                _createVNode(_component_el_table_column, { prop: "name" }),
                                _createVNode(_component_el_table_column, { prop: "func_name" }, {
                                  default: _withId((scope) => [
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(scope.row.data, (item) => {
                                      return (_openBlock(), _createBlock("div", { key: item }, [
                                        _createTextVNode(_toDisplayString(item.name), 1),
                                        _createVNode("span", _hoisted_47, _toDisplayString(item.size), 1),
                                        _hoisted_48,
                                        _createVNode("span", {
                                          style: 'color:' + _ctx.getCom(item.change)[1]
                                        }, _toDisplayString(_ctx.getCom(item.change)[0]), 5),
                                        _hoisted_49
                                      ]))
                                    }), 128))
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["data"])
                          ])
                        ]),
                        _createVNode("div", _hoisted_50, [
                          _createVNode("div", null, [
                            _hoisted_51,
                            _createVNode(_component_h8, { style: {"display":"flex","align-items":"center"} }, {
                              default: _withId(() => [
                                _hoisted_52,
                                _hoisted_53
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_card, null, {
                              default: _withId(() => [
                                _hoisted_54
                              ]),
                              _: 1
                            })
                          ]),
                          _createVNode("div", null, [
                            _createVNode(_component_h8, { style: {"display":"flex","align-items":"center"} }, {
                              default: _withId(() => [
                                _hoisted_55,
                                _hoisted_56
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_table, {
                              border: "",
                              "header-cell-style": {
                          background: '#f5f7fa',
                        },
                              data: _ctx.get_core_data.class_rate
                            }, {
                              default: _withId(() => [
                                _createVNode(_component_el_table_column, {
                                  label: "名称",
                                  prop: "name"
                                }),
                                _createVNode(_component_el_table_column, {
                                  prop: "count",
                                  label: "Count"
                                }),
                                _createVNode(_component_el_table_column, {
                                  prop: "size",
                                  label: "size"
                                }),
                                _createVNode(_component_el_table_column, {
                                  prop: "rate",
                                  label: "百分比"
                                })
                              ]),
                              _: 1
                            }, 8, ["data"])
                          ])
                        ]),
                        _createVNode("div", _hoisted_57, [
                          _hoisted_58,
                          _createVNode(_component_h8, { style: {"display":"flex","align-items":"center"} }, {
                            default: _withId(() => [
                              _hoisted_59,
                              _hoisted_60
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_card, {
                            id: "mi_chart",
                            style: {"height":"500px"}
                          }),
                          _createVNode(_component_el_table, {
                            style: {"margin-top":"20px"},
                            "span-method": _ctx.cellMerge,
                            "header-cell-style": {
                        background: '#f5f7fa',
                      },
                            border: "",
                            data: _ctx.top_10
                          }, {
                            default: _withId(() => [
                              _createVNode(_component_el_table_column, {
                                label: "主资产文件",
                                prop: "name"
                              }),
                              _createVNode(_component_el_table_column, {
                                label: "资源",
                                prop: "func_name"
                              }),
                              _createVNode(_component_el_table_column, {
                                label: "Size",
                                prop: "size"
                              })
                            ]),
                            _: 1
                          }, 8, ["span-method", "data"])
                        ])
                      ], 512), [
                        [_directive_loading, _ctx.loading]
                      ])
                    ])
                  ])
                ]),
                _hoisted_61
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})